import React from 'react'
import { useGlobalSearch } from '../../hooks/useGlobalSearch'
import { products } from '../../data'
import { Link } from 'react-router-dom'
// import {
//   ClipboardDocumentCheckIcon,
//   PencilSquareIcon,
//   CalculatorIcon,
//   DocumentTextIcon
// } from '@heroicons/react/24/outline'
import { ClipboardCheckIcon, PencilAltIcon, CalculatorIcon, DocumentTextIcon } from "@heroicons/react/outline";

const Release_notes = () => {

    const { query, setQuery, resultados } = useGlobalSearch()
    const app = products.find(p => p.id === 'release_notes')
  
    // Tomamos los últimos 3 artículos de Aplicación Invu POS
    const ultimas = app.subcategorias
    .flatMap(cat => cat.articulos)
    .filter(a => a.fecha)
    .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
    .slice(0, 3)

    
  return (
    <>
    {/* Hero + Buscador */}
    <div className="mb-16 mt-12 px-6">
      <div
        className="px-4 py-12 mx-auto md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-20 lg:py-12 \
                    bg-[#d3e4f7] rounded-t-2xl overflow-hidden \
                    bg-[url('https://img.invupos.com/webinvu/Pattern_v2_cl1wil.png')] \
                    bg-no-repeat bg-cover bg-center"
      >
        <h2 className="lg:text-5xl text-4xl font-bold text-gray-800 mb-4">
          {app.nombre}
        </h2>
        <p className="lg:text-xl text-lg text-gray-700">
          {app.descripcion}
        </p>
      </div>

      <div className="relative sm:px-0">
        <div className="absolute inset-0 bg-[#d3e4f7] h-1/2 mx-auto lg:max-w-screen-xl sm:max-w-xl md:max-w-full rounded-b-2xl" />
        <div className="relative grid mx-auto overflow-visible bg-white rounded-b-2xl sm:rounded-2xl shadow p-4 lg:max-w-screen-lg">
          <h3 className="xl:text-3xl text-lg font-bold mb-4 mt-2">¿Cómo podemos ayudarle?</h3>
          <div className="flex flex-col lg:flex-row items-center gap-4 w-full">
            <div className="relative w-full lg:flex-1">
              <input
                type="text"
                placeholder="Cuéntanos tu problema..."
                value={query}
                onChange={e => setQuery(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-gray-200 shadow-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {query && resultados.length > 0 && (
                <ul className="absolute top-full left-0 right-0 z-10 bg-white border border-gray-200 rounded-b-2xl shadow-lg max-h-60 overflow-auto mt-1">
                  {resultados.map(item => (
                    <li key={`${item.producto}-${item.id}`} className="px-4 py-2 hover:bg-gray-100 flex items-center gap-2">
                      <DocumentTextIcon className="h-5 w-5 text-blue-500" />
                      <Link to={item.enlace} onClick={() => window.scrollTo(0, 0)} className="flex-1 text-gray-800">
                        {item.titulo}
                      </Link>
                      <span className="text-xs text-gray-400">{item.producto}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <button
              onClick={() => {}}
              className="w-full lg:w-auto flex items-center justify-center gap-2 px-5 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition"
            >
              Buscar
            </button>
          </div>
        </div>
      </div>
    </div>


    {/* <div className="px-4 py-12 mx-auto md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-20 lg:py-12">
      <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
        <div className="flex items-start gap-3 px-6 py-5 border-b">
          <ClipboardCheckIcon className="h-8 w-8 text-blue-600" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800">
              {app.nombre}{' '}
              <span className="text-gray-400">({app.subcategorias.length})</span>
            </h2>
            <p className="text-gray-600 mt-1">{app.descripcion}</p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 divide-y lg:divide-y-0 lg:divide-x divide-gray-200">
          {app.subcategorias.map((cat, idx) => (
            <div key={cat.id} className={`p-6 ${idx >= 2 ? 'pt-5' : ''}`}>
              <img src={cat.img} className="w-96" />
              <div className="flex items-center gap-2 mb-4">
                {cat.icon}
                <h3 className="text-xl font-semibold text-gray-800">
                  {cat.nombre}{' '}
                  <span className="text-gray-400">({cat.articulos.length})</span>
                </h3>
              </div>
              <ul className="space-y-2 mb-3">
                <li>
                  <Link to={cat.articulos[0].enlace} onClick={() => window.scrollTo(0, 0)} className="flex items-center text-blue-600 hover:underline">
                    <DocumentTextIcon className="h-5 w-5 mr-2" />
                    {cat.articulos[0].titulo}
                  </Link>
                </li>
              </ul>
              {cat.articulos.length > 1 && (
                <Link to={`/${app.id}/${cat.id}`} className="text-sm text-blue-500 hover:underline">
                  Ver todo {cat.articulos.length}
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </div> */}


<section className="py-20" id="release-notes">
  <div className="max-w-screen-xl mx-auto px-8">
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h2 className="text-3xl font-bold text-gray-800">
          {app.nombre}{' '}
          <span className="text-gray-400">({app.subcategorias.length})</span>
        </h2>
        <p className="text-gray-600 mt-1">{app.descripcion}</p>
      </div>

      {/* Primer grid: 2 columnas */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {app.subcategorias.slice(0, 2).map((cat) => (
          <div key={cat.id} className="group bg-white rounded-2xl shadow-lg overflow-hidden">
            <div
              className={`h-80 flex items-center justify-center bg-gray-50 transition-colors duration-300 group-hover:${cat.hover}`}
            >
              <img
                src={cat.img}
                alt={cat.nombre}
                className="max-h-full max-w-full object-contain"
              />
            </div>
            <div className="p-4">
              <div className="flex space-x-2 items-center">
                <h3 className="text-xl font-semibold">{cat.nombre}</h3>
                <span className="text-gray-400 text-xl">({cat.articulos.length})</span>
                {cat.articulos.length === 0 && (
                  <span className="inline-flex items-center rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700 ring-1 ring-inset ring-purple-700/10">
                    PRÓXIMAMENTE
                  </span>
                )}
              </div>

              {/* Artículo si existe */}
              {cat.articulos?.length > 0 && (
                <ul className="mt-2 space-y-1 text-[18px] text-blue-600 mb-4">
                  {cat.articulos.map((articulo) => (
                    <li key={articulo.id}>
                    <div className="flex items-center space-x-2">
                        <Link
                          to={articulo.enlace}
                          onClick={() => window.scrollTo(0, 0)}
                          className="hover:underline flex items-center text-blue-600"
                        >
                          <DocumentTextIcon className="h-4 w-4 mr-1" />
                          {articulo.titulo}
                        </Link>

                        {articulo.area && (
                          <span className="inline-flex items-center rounded-md bg-gray-100 px-1 py-0.5 text-xs font-medium text-gray-700 ring-1 ring-inset ring-gray-300">
                            {articulo.area}
                          </span>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Segundo grid: 3 columnas */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {app.subcategorias.slice(2).map((cat) => (
          <div key={cat.id} className="group bg-white rounded-2xl shadow-lg overflow-hidden">
            <div
              className={`h-80 flex items-center justify-center bg-gray-50 transition-colors duration-300 group-hover:${cat.hover}`}
            >
              <img
                src={cat.img}
                alt={cat.nombre}
                className="max-h-full max-w-full object-contain"
              />
            </div>
            <div className="p-4">
              <div className="flex space-x-2 items-center">
                <h3 className="text-base font-medium">{cat.nombre}</h3>
                <span className="text-gray-400">({cat.articulos.length})</span>
                {cat.articulos.length === 0 && (
                  <span className="inline-flex items-center rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700 ring-1 ring-inset ring-purple-700/10">
                    PRÓXIMAMENTE
                  </span>
                )}
              </div>

              {/* Artículo si existe */}
              {cat.articulos?.[0] && (
                <ul className="mt-2 space-y-1 text-sm text-blue-600">
                  <li>
                    <Link
                      to={cat.articulos[0].enlace}
                      onClick={() => window.scrollTo(0, 0)}
                      className="hover:underline flex items-center"
                    >
                      <DocumentTextIcon className="h-4 w-4 mr-1" />
                      {cat.articulos[0].titulo}
                    </Link>
                  </li>
                </ul>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>
    
    
    {/* Sección de Últimas actualizaciones (últimos 3 artículos) */}
    <section className='bg-gray-50'>
    <div className="px-4 py-12 mx-auto md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-20 lg:py-12">
      <h3 className="text-2xl font-bold mb-4">Últimas actualizaciones</h3>
      <div className="space-y-4">
            {ultimas.map(a => (
              <Link
                key={a.id}
                to={a.enlace}
                onClick={() => window.scrollTo(0, 0)}
                className="flex items-center justify-between bg-white rounded-2xl p-4 shadow hover:bg-gray-50"
              >
                {/* IZQUIERDA: icono + título + origen */}
                <div className="flex items-center gap-4">
                  <DocumentTextIcon className="h-8 w-8 text-blue-600" />
                  <div>
                    <h4 className="font-semibold text-gray-800">{a.titulo}</h4>
                    <p className="text-sm text-gray-500">{app.nombre}</p>
                  </div>
                </div>
                {/* DERECHA: fecha tal cual */}
                <p className="text-xs text-gray-400">{a.fecha}</p>
              </Link>
            ))}
          </div>
    </div>
    </section>
  </>
  )
}

export default Release_notes